import { Reveal, Eyebrow } from "./Reveal";
import { MilestoneCarousel } from "./MilestoneCarousel";
import { leadership } from "../../data/resume";

export const Leadership = () => {
  return (
    <section
      id="leadership"
      data-testid="leadership-section"
      className="mx-auto max-w-[1400px] px-6 sm:px-12 lg:px-20 py-24 lg:py-36"
    >
      <Reveal>
        <Eyebrow>(Leadership)</Eyebrow>
        <h2 className="mt-6 max-w-3xl font-serif font-normal text-4xl sm:text-5xl lg:text-6xl leading-[1.03] text-ink">
          Flagship moments on the biggest stages.
        </h2>
      </Reveal>

      <div className="mt-16 lg:mt-24 flex flex-col gap-16 lg:gap-28">
        {leadership.map((item, i) => {
          const hasImages = item.images && item.images.length > 0;
          const flip = i % 2 === 1;
          return (
            <Reveal key={item.id} delay={0.05}>
              <div
                data-testid={`leadership-item-${i}`}
                className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-14 items-center"
              >
                <div
                  className={`lg:col-span-5 ${
                    !hasImages
                      ? "lg:col-span-8"
                      : flip
                      ? "lg:order-2 lg:col-start-8"
                      : "lg:col-start-1"
                  }`}
                >
                  <span className="font-mono text-xs text-rust">
                    0{i + 1} / FEATURED
                  </span>
                  <h3 className="mt-5 font-serif text-3xl sm:text-4xl text-ink leading-tight">
                    {item.event}
                  </h3>
                  <p className="mt-5 font-sans text-base sm:text-lg leading-relaxed text-inksoft">
                    {item.body}
                  </p>
                </div>

                {hasImages && (
                  <div
                    className={`lg:col-span-7 ${
                      flip ? "lg:order-1 lg:col-start-1" : "lg:col-start-6"
                    }`}
                  >
                    <MilestoneCarousel
                      images={item.images}
                      alt={item.event}
                      testid={`milestone-carousel-${item.id}`}
                    />
                  </div>
                )}
              </div>
            </Reveal>
          );
        })}
      </div>
    </section>
  );
};
